import { useQuery } from '@tanstack/react-query';
import { useMemo, useRef } from 'react';
import axiosInstance from '../../axiosConfig';

const fetchMediasToQualifyCountStatus = async (params) => {
  const response = await axiosInstance.get('/medias/count/', {
    params,
  });
  return response.data;
};

const useStableParams = (params) => {
  const paramsRef = useRef(params);
  const serialized = JSON.stringify(params);
  const serializedRef = useRef(serialized);

  if (serializedRef.current !== serialized) {
    serializedRef.current = serialized;
    paramsRef.current = params;
  }

  return paramsRef.current;
};

export const useGetMediasToQualifyCountStatus = (params = {}, options = {}) => {
  const stableParams = useStableParams(params);

  const queryParams = useMemo(() => {
    const out = {};
    Object.entries(stableParams).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
  }, [stableParams]);

  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['medias', queryParams],
    queryFn: () => fetchMediasToQualifyCountStatus(queryParams),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  const counts = data;

  const toQualifyCount = counts?.to_qualify_count;
  const toValidateCount = counts?.to_validate_count;
  const validatedCount = counts?.validated_count;
  const rejectedCount = counts?.rejected_count;
  const archivedCount = counts?.archived_count;
  const totalCount = counts?.total_count;

  return {
    counts,
    toQualifyCount,
    toValidateCount,
    validatedCount,
    rejectedCount,
    archivedCount,
    totalCount,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
